import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseNotifications from '../../AbstractObjects/GatewayPlan/InnerPages/BaseNotifications';

const pageSchema = GatewayGetSchema.pages.notifications;
const pageId = pageSchema.pageId;

function PlanNotifications({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];
    
    return (
        <BaseNotifications
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanNotifications;